import { memo } from 'react';
import { trans } from '@lingoda/i18n';
import { Box, Typography } from '@lingoda/ui';
import { getLessonSubtitle } from '../../helpers';

interface Props {
    lessonTitle: string;
    chapterName: string;
    moduleName: string;
    lessonLabel: string;
    classTypeInfo: string;
    hasTeacher: boolean;
}

const ClassTileInfoComponent = ({
    moduleName,
    chapterName,
    lessonTitle,
    lessonLabel,
    classTypeInfo,
    hasTeacher,
}: Props) => {
    const subtitle = getLessonSubtitle(moduleName, chapterName, lessonLabel);

    return (
        <Box sx={{ mb: 1 }}>
            <Box sx={{ mb: 2 }}>
                <Box sx={{ mb: 1 }}>
                    <Typography
                        variant="h3"
                        data-cy="classTileInfo_lessonTitle"
                        htmlColor="text.primary"
                    >
                        {lessonTitle}
                    </Typography>
                </Box>
                <Typography
                    variant="overline"
                    data-cy="classTileInfo_subtitle"
                    htmlColor="text.secondary"
                >
                    {subtitle}
                </Typography>
            </Box>
            <Typography
                variant="overline"
                data-cy="classInfo_classTypeInfo"
                htmlColor="text.secondary"
            >
                {classTypeInfo}
            </Typography>
            {!hasTeacher && (
                <Box sx={{ mt: 1 }}>
                    <Typography variant="overline" htmlColor="text.secondary">
                        {trans('teacher-will-be-assigned', {}, 'student-common')}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export const ClassTileInfo = memo(ClassTileInfoComponent);
